export const services = [
  {
    id: 1,
    title: "Industrial Safety",
    description: "Our Industrial Safety division provides technical training and consulting services designed to keep your operations safe, efficient, and compliant. We deliver customized safety programs, jobsite audits, and risk management strategies that align with the unique demands of industrial worksites.",
    icon: "ShieldCheck",
    features: ["24/7 support for urgent safety needs", 
      "Certified inspectors", 
      "Experienced trainers", 
      "Expert consultants"],
    color: "from-orange-500 to-red-500"
  },
  {
    id: 2,
    title: "Workforce Development",
    description: "Our Workforce Development division delivers technical training and support services designed to build stronger, more capable teams. We provide end-to-end solutions that prepare workers with the technical skills needed to perform efficiently and effectively in today’s industries. Key Advantages:",
    icon: "Users",
    features: ["Identify workforce needs", "Development and management", "Technical training OJT", "Post assessments"],
    color: "from-blue-500 to-cyan-500"
  },
  {
    id: 3,
    title: "TxDOT & Environmental",
    description: "Our TxDOT & Environmental division provides technical consulting services and training to help organizations meet transportation and environmental standards. We support companies in navigating complex regulations while developing policies and programs that ensure compliance and sustainability. ",
    icon: "ArrowDownUpIcon",
    features: ["TxDOT regulations consultancy", "Policy creation ", "SWPPP", "TxDOT mapping"],
    color: "from-green-500 to-emerald-500"
  },
  {
    id: 4,
    title: "Software (MWT)",
    description: "Our MWT software streamlines workforce management by combining scheduling, tracking, and performance tools into one easy-to-use platform. Designed to support both employees and management, it simplifies daily operations, improves communication, and ensures projects are completed on time and within compliance.",
    icon: "Monitor",
    features: ["Workforce scheduling and tracking", "Real-time performance monitoring", "Training and certification management", "Reporting and compliance tools"],
    color: "from-purple-500 to-indigo-500"
  }
];

export const stats = [
  { number: "75", label: "Years Experience", icon: "Calendar" },
  { number: "500+", label: "Companies Served", icon: "Factory" },
  { number: "10K+", label: "Workers Trained", icon: "Users" },
  { number: "99%", label: "Platform Record", icon: "Shield" }
];